<!--
 * @Author: Axs <i@axs.email>
 * @Date: 2020-08-04 18:48:05
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2021-05-08 18:02:17
 * @Description: 
 * @FilePath: /src/components/order/btn.vue
--> 
<style lang="less" scoped>
    @import url('~@/lib/base.less');
    .order-btn {
        margin-top: .pxToRem(30) [];
        .sq(96);
        background: @theme_color_first;
        border-radius: 100%;
        box-shadow: .pxToRem(3) [] .pxToRem(8) [] .pxToRem(15) [] 0 rgba(0, 0, 0, 0.15);
        .order-img {
            .base-center-x;
            top: .pxToRem(16) [];
            .sq(40);
            pointer-events: all;
        }
        .text {
            .base-center-x;
            bottom: .pxToRem(10) [];
            font-size: .pxToRem(20) [];
            color: rgba(0, 0, 0, 0.9);
            height: .pxToRem(28) [];
            line-height: .pxToRem(28) [];
        }
    }
</style>

<template>
    <div class="components order-btn">
        <img class="order-img"
             @click="toOrderList"
             :src="require('@/assets/icons/icon-order-btn.png')">
        <div class="text">订单</div>
    </div>
</template>
<script>
    import { PAGE_ORDER_LIST } from 'page';
    export default {
        methods: {
            toOrderList() {
                if (this.$store.state.user.token) {
                    this.$util.pageJump(PAGE_ORDER_LIST)
                }
                else {
                    this.$loginModel.open();
                }
            }
        }
    }
</script>

